<template>
  <DataListStateful
    title="Города"
    resource="cities"
    store="cities"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        {
          title: "Наименование",
          name: "title",
          dataPath: "Title",
          sortable: true,
        },
        {
          title: "Область",
          name: "district",
          dataPath: "District.Title",
          sortable: true,
        },
        {
          title: "Регион",
          name: "region",
          dataPath: "Region.Title",
          sortable: true,
        },
        {
          title: "Страна",
          name: "country",
          dataPath: "Country.Title",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        district: {
          title: "Область",
          type: "reference",
          resource: "districts",
        },
        region: {
          title: "Регион",
          type: "reference",
          resource: "regions",
        },
        country: {
          title: "Страна",
          type: "reference",
          resource: "countries",
        },
      },
    };
  },
};
</script>
